import React, { Component } from 'react';
import moment from 'moment';
import unescape from 'lodash/unescape';

import Icon from 'components/common/Icon';

export default class ScheduleList extends Component {

  renderList() {
    const { schedules, renderItem } = this.props;

    if (schedules.length === 0) {

      return (
        <div>
          <div className="list-group">
            <div className="list-item">
              <div className="inner">
                <div className="no-events">No Schedules</div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div key="listGroup">
        <div className="list-group">
          {schedules.map((schedule, key) => {
            if (schedules.length > 1 && key + 1 < schedules.length) {
              return renderItem(schedule, true);
            }
            return renderItem(schedule);
          })}
        </div>
      </div>
    );
  }

  render() {
    const { schedules, isLoading } = this.props;

    if (!Array.isArray(schedules) || (schedules.length === 0 && isLoading)) {
      // Could display a loading spinner but parent is handling this for now
      return <span />;
    }

    return (
      <section className="full-screen-list">
        {this.renderList()}
      </section>
    );
  }
}

ScheduleList.defaultProps = {
  isLoading: true,
};



// WEBPACK FOOTER //
// ./src/app/components/calendar/ScheduleList.js